import { card, invoice, paypal } from '../constants/payData';
import { paymentTypeId } from '../constants/paymentTypeId';

export function getPaymentMethodId(paymentMethod: string | null | undefined): number {
  switch (paymentMethod) {
    case card:
      return paymentTypeId.card;
    case invoice:
      return paymentTypeId.invoice;
    case paypal:
      return paymentTypeId.paypal;
    default:
      return paymentTypeId.card;
  }
}
